import PropTypes from "prop-types";
import useAppContext from "common/hooks/use-app-context";
import useI18n from "common/hooks/use-i18n";

function EmailLink({assessmentID}) {
  const {current: {organization}} = useAppContext();
  const i18n = useI18n();
  const body = i18n.t("results.email_body", {
    personality_url: `${organization.url}/personality/${assessmentID}`,
    session_url: `${organization.url}/sessions/new`
  }).replace(/ /g, "%20");
  const subject = `Traitify ${i18n.t("results.personality_results")}`.replace(/ /g, "%20");
  const href = `mailto:?subject=${subject}&body=${body}`;
  const title = i18n.t("results.email");

  return (
    <div className="nav-item">
      <a className="nav-link" href={href} rel="noopener noreferrer" target="_blank" title={title}>
        <i className="fa fa-envelope-o" />
      </a>
    </div>
  );
}

EmailLink.propTypes = {assessmentID: PropTypes.string.isRequired};

export default EmailLink;
